module.exports = __webpack_public_path__ + "media/icons/breadcrumbs-arrow@3x-467de04e.svg";